module.exports = __webpack_public_path__ + "static/MobileLogin-be33de6e358e4855fa13e9a7f593fb10.png";